export enum NotificationType {
  None = 0,
  Message,
  ProjectMessage,
  WorkUnitMessage,
  DataUpdateMarker,

  WorkUnit,
  QualityCheckItem,
  DoneQualityCheckItem,
  EmployeeHours,
  WorkUnitEmployeeAssignment,
  StaffingEmployeeAssignment,
}
